import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'experienceCardTitle',
  standalone: false,
})
export class ExperienceCardTitlePipe implements PipeTransform {
  transform(
    displayedColumns: string[],
    title: { sentiment: string; document: string }
  ): string | boolean {
    return displayedColumns.includes('sentiment') ? title.sentiment : title.document;
  }
}
